import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-6",
  "use": "menu-6-usage",
  "viewBox": "0 0 36.75 42",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36.75 42\" id=\"menu-6\"><title>资源 10</title><g data-name=\"图层 2\"><path d=\"M0 2.62A2.63 2.63 0 0 1 2.64 0h31.47a2.63 2.63 0 0 1 2.64 2.62v36.75A2.63 2.63 0 0 1 34.11 42H2.64A2.63 2.63 0 0 1 0 39.38zm7.87 6.57a1.33 1.33 0 0 0 1.32 1.31h18.37a1.31 1.31 0 1 0 0-2.62H9.19a1.32 1.32 0 0 0-1.32 1.31zm0 7.87a1.31 1.31 0 0 0 1.29 1.31h7.93a1.29 1.29 0 0 0 1.29-1.31 1.31 1.31 0 0 0-1.29-1.31H9.16A1.29 1.29 0 0 0 7.87 17zm0 7.87a1.32 1.32 0 0 0 1.29 1.31h13.18a1.31 1.31 0 0 0 0-2.62H9.16a1.31 1.31 0 0 0-1.29 1.32zm0 7.87a1.33 1.33 0 0 0 1.31 1.31h18.38a1.31 1.31 0 0 0 0-2.62H9.19a1.32 1.32 0 0 0-1.32 1.32z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-6.svg
// module id = 3tQT
// module chunks = 6